export default __webpack_public_path__ + "img/cityscape.ab176778.png";